import React from "react";
import styles from "./messenger.module.css";
import SenderMessage from "./SenderMessage";
import io from "socket.io-client";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const Messenger = ({}) => {
  const [conversations, setConversations] = useState([]);
  const [user, setUser] = useState([]);

  useEffect(()=>{
    getCoversations();
    getUser()
  } , []);


  const getUser = () => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-user/${"z49yZtYbbwNqkKjZNKNu1C9AmuGaXGQpV51MmDNljdQYWHvVEWCFgnaqfiBCSJzUBHU0bld8jjbBdIpE"}`)
      .then((response) => {
        console.log("user", response.data);
        setUser(response.data);
      });
  }

  
  const getCoversations = () => {
    axios.get(`https://arianaapp.arianaapply.com/api/V1/get-clients-for-admissioner/${"62b33ec33540070013e8d29e"}`)
    .then(res=>{
      console.log('convs' , res);
      setConversations(res.data);
    }).catch(err=>{
      console.log(err);
    })
  }


  return (
    <div className={styles.messenger}>
      {conversations && conversations.map((c) => (
        <SenderMessage key={c._id} conv={c} user={user} />
      ))}
    </div>
  );
};

export default Messenger;
